import { CreateStepArgs } from '@/lib/Steppers/CreateStepper/types';
import { CampaignIcon, DataSourcesIcon } from '@/lib';
import { WhatsappCampaignStep } from './WhatsappCampaignValidation';

export type WhatsappCampaignMode = 'create' | 'edit';

export const WHATSAPP_CAMPAIGN_STEPS = [
  {
    id: 'TitleDescription',
    title: 'campaign:whatsappWorkspace:steps:title',
    icon: CampaignIcon,
    isCompleted: false,
  },
  {
    id: 'AudienceSelection',
    title: 'campaign:whatsappWorkspace:steps:audienceSelection',
    icon: DataSourcesIcon,
    isCompleted: false,
  },
  {
    id: 'TemplateSelection',
    title: 'campaign:whatsappWorkspace:steps:templateSelection',
    icon: DataSourcesIcon,
    isCompleted: false,
  },
  {
    id: 'PreviewSchedule',
    title: 'campaign:whatsappWorkspace:steps:previewAndSend',
    icon: CampaignIcon,
    isCompleted: false,
  },
] as const satisfies ReadonlyArray<CreateStepArgs<WhatsappCampaignStep>>;

// Edit flow skips the template-selection wizard; the campaign already
// has a connectorFlowInstance and we only let users tweak campaign metadata.
export const WHATSAPP_CAMPAIGN_EDIT_STEPS = WHATSAPP_CAMPAIGN_STEPS.filter(
  (step) => step.id !== 'TemplateSelection'
) as ReadonlyArray<CreateStepArgs<WhatsappCampaignStep>>;

export const getWhatsappCampaignSteps = (mode: WhatsappCampaignMode) =>
  mode === 'edit' ? WHATSAPP_CAMPAIGN_EDIT_STEPS : WHATSAPP_CAMPAIGN_STEPS;
